// extracted by mini-css-extract-plugin
module.exports = {"categoryListBlock":"CategoryListBlock_categoryListBlock__Y3aW9","categoryListBlockRedesign":"CategoryListBlock_categoryListBlockRedesign__6yc3X"};